import React, { useEffect, useState } from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencyBar() {
  const [targetDate, setTargetDate] = useState<Date | null>(null);
  useEffect(() => {
    // Set target date to 2 hours from now on mount
    const date = new Date();
    date.setHours(date.getHours() + 2);
    setTargetDate(date);
  }, []);
  if (!targetDate) return null;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-red-600 via-orange-500 to-red-600 py-2 px-4 shadow-lg" data-id="element-143">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center text-center text-white text-sm md:text-base font-medium gap-1 md:gap-2" data-id="element-144">
        <span data-id="element-145">
          🔥 <strong data-id="element-146">OFERTA DE LANZAMIENTO:</strong> 85% de DESCUENTO disponible
          solo para los próximos 47 cupos.
        </span>
        <span className="flex items-center gap-2" data-id="element-147">
          El reloj se detiene en:{' '}
          <CountdownTimer targetDate={targetDate} className="bg-black/20 px-2 py-0.5 rounded" data-id="element-148" />
        </span>
      </div>
    </div>;
}